import { useState, useEffect, useContext } from "react";
import { Modal } from "react-bootstrap";
import { CustomTooltip } from "../kits/tooltip/CustomTooltip";
import CustomButton from "../kits/button/CustomButton";
import { CustomInput, ReactSelect } from "../kits/Inputs/Inputs.tsx";
import DatePiker from "../datepiker/datePiker.jsx";
import ToastCustomize from "../kits/ToastCustomize";
import { ExitIcon } from "../kits/Icons.tsx";
import useAxios from "../../services/useAxios.tsx";

import AuthenticationContext from "../../Authentication/AuthenticationContext";

export default function ExitStorageModal({ data, users, setUpdater }) {
  const { execute: registerApi } = useAxios("api2/receipt_registration");

  const { userInfo } = useContext(AuthenticationContext);
  const [exitShow, setExitShow] = useState(false);
  const [exitStorageData, setExitStorageData] = useState({
    count: "",
    date: "",
    receiver: "",
    description: "",
  });
  console.log("exitdata", data);
  const [validate, setValidate] = useState({
    count: true,
    date: true,
    user: true,
    inventory: true,
  });
  const validation = () => {
    let isValid = true;
    if (exitStorageData.count == "") {
      isValid = false;
      setValidate((prev) => {
        return { ...prev, count: false };
      });
    }
    if (exitStorageData.count > +data.inventory) {
      isValid = false;
      setValidate((prev) => {
        return { ...prev, inventory: false };
      });
    }
    if (exitStorageData.date == "") {
      isValid = false;
      setValidate((prev) => {
        return { ...prev, date: false };
      });
    }
    if (exitStorageData.receiver?.length == 0) {
      isValid = false;
      setValidate((prev) => {
        return { ...prev, user: false };
      });
    }
    return isValid;
  };
  const clearData = () => {
    setValidate({
      count: true,
      date: true,
      user: true,
      inventory: true,
    });
    setExitStorageData({
      count: "",
      receiver: [],
      description: "",
      date: "",
    });
  };
  const exitBill = () => {
    // pServiceId,type,count,whiteHouseItemId,reciverId,senderId,status,usertoken
    let fd = new FormData();
    fd.append("pServiceId", data.product_services__id);
    fd.append("type", 0);
    fd.append("count", exitStorageData.count);
    fd.append("whiteHouseItemId", data.white_house_item__id);
    fd.append("senderId", userInfo.id);
    fd.append("reciverId", exitStorageData.receiver?.value);
    fd.append("status", 1);
    fd.append("do_tm", exitStorageData.date);
    fd.append("description", exitStorageData.description);
    registerApi(fd).then((data) => {
      if (data.status == 1) {
        ToastCustomize({
          mainText: "  خروج از انبار با موفقیت ثبت شد",
          duration: 3000,
          toastType: "success",
          color: "success",
          position: "top-center",
          hasHeader: false,
        });
        setExitStorageData({
          count: "",
          receiver: [],
          description: "",
          date: "",
        });
        setExitShow(false);
        setUpdater((prev) => !prev);
      } else {
        ToastCustomize({
          mainText: "مشکلی در ثبت پیش آمد",
          duration: 3000,
          toastType: "warning",
          color: "warning",
          position: "top-center",
          hasHeader: false,
        });
        setExitStorageData({
          count: "",
          receiver: [],
          description: "",
          date: "",
        });
        setExitShow(false);
      }
    });
  };
  return (
    <>
      {userInfo.userRoll.includes(40) && (
        <CustomTooltip
          title="خروج از انبار"
          placement="top"
          color="secondary_custom"
        >
          <div>
            <CustomButton
              className="shadow-none"
              onClick={() => {
                setExitShow(true);
              }}
            >
              <ExitIcon color="white" />
            </CustomButton>
          </div>
        </CustomTooltip>
      )}
      <Modal
        show={exitShow}
        onHide={() => {
          setExitShow(false);
          clearData();
        }}
      >
        <Modal.Header closeButton> خروج از انبار</Modal.Header>
        <Modal.Body>
          <div className="px-3">
            <div className="mt-4">
              <CustomInput
                type="text"
                label="نام محصول"
                activate="disabled"
                inputValue={data?.title}
              ></CustomInput>
            </div>
            <div className="mt-4">
              <CustomInput
                type="text"
                label="تعداد"
                inputValue={exitStorageData.count}
                onChangeFunc={(e) => {
                  setExitStorageData((prev) => {
                    return { ...prev, count: e.target.value };
                  });
                }}
              ></CustomInput>
              <p
                className="text-danger mt-1"
                style={{
                  display: validate.count ? "none" : "block",
                  fontSize: 10,
                }}
              >
                تعداد را وارد کنید
              </p>
              <p
                className="text-danger mt-1"
                style={{
                  display: validate.inventory ? "none" : "block",
                  fontSize: 10,
                }}
              >
                تعداد نمی تواند بیشتر از موجودی باشد
              </p>
            </div>
            <div className="mt-4">
              <ReactSelect
                title="کاربر تحویل گیرنده"
                itemsList={users}
                inputValue={exitStorageData.receiver}
                onChangeFunc={(e) => {
                  setExitStorageData((prev) => {
                    return { ...prev, receiver: e };
                  });
                }}
              />
              <p
                className="text-danger mt-1"
                style={{
                  display: validate.user ? "none" : "block",
                  fontSize: 10,
                }}
              >
                کاربر را انتخاب کنید
              </p>
            </div>
            <div className="mt-4">
              <label
                style={{
                  color: "#677788",
                  fontSize: "0.75rem",
                  marginBottom: "0.5rem",
                }}
              >
                تاریخ
              </label>
              <div className="w-100">
                <DatePiker
                  type_calender={"jalali"}
                  // location={"right"}
                  //   color={"purple"}
                  //   bg={"bg-dark"}
                  buttons={true}
                  inputSize={"text"}
                  value={exitStorageData.date * 1000}
                  setValue={(e) => {
                    setExitStorageData((prev) => {
                      return { ...prev, date: e.unix };
                    });
                  }}
                ></DatePiker>
                <p
                  className="text-danger mt-1"
                  style={{
                    display: validate.date ? "none" : "block",
                    fontSize: 10,
                  }}
                >
                  تاریخ را وارد کنید
                </p>
              </div>
            </div>
            <div className="my-4">
              <CustomInput
                label="توضیحات"
                inputType="textarea"
                inputSize="lg"
                inputValue={exitStorageData.description}
                onChangeFunc={(e) => {
                  setExitStorageData((prev) => {
                    return { ...prev, description: e.target.value };
                  });
                }}
              ></CustomInput>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end mt-3">
            <CustomButton
              color="danger"
              className="mx-3"
              onClick={() => {
                setExitShow(false);
                clearData();
              }}
            >
              انصراف
            </CustomButton>
            <CustomButton
              color="success"
              onClick={() => {
                if (validation()) {
                  exitBill();
                }
              }}
            >
              ثبت
            </CustomButton>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}
